export default class GetInfoMediatorResponse {
  id: string
  identifierCode: string
  userDescription: string
  mediatorId: string
  mediatorPhone: string
  mediatorEmail: string
  mediatorImage: string
  mediatorHtml: string
  mediatorUrl: string
  allowedBusinessLines: {
    health: boolean
    foreignHealth: boolean
    dental: boolean
    pets: boolean
    travel: boolean
    life: boolean
    home: boolean
  }

  constructor(data: any) {
    this.id = data.id
    this.identifierCode = data.identifierCode
    this.userDescription = data.userDescription
    this.mediatorId = data.mediatorId
    this.mediatorPhone = data.mediatorPhone
    this.mediatorEmail = data.mediatorEmail
    this.mediatorImage = data.mediatorImage

    this.mediatorHtml = data.mediatorHtml
    this.mediatorUrl = data.mediatorUrl
    this.allowedBusinessLines = data.allowedBusinessLines
  }
}
